module.exports = __webpack_public_path__ + "static/media/SmartShop_4-727w.d69ec034.png";